import styled from "styled-components"
import { Row, Col } from "antd"

export const WrapListCourse = styled(Row)`
  padding: 16px 0 24px;

  .title-list {
    font-size: 18px;
    font-weight: 600;
    text-transform: uppercase;
  }
`

export const CourseItemStyle = styled(Col)`
  .ant-ribbon {
    right: -6px;
    top: 5px;
  }
  .hidden-ribbon {
    .ant-ribbon-text,
    .ant-ribbon-corner {
      display: none;
    }
  }
  .card-course {
    box-shadow: 0 2px 4px rgb(0 0 0 / 8%), 0 4px 12px rgb(0 0 0 / 8%);
    cursor: pointer;
    transition: all 0.1s ease-in-out;
    &:hover {
      box-shadow: 0 4px 8px #62b0fd, 0 4px 12px rgb(0 0 0 / 8%);
    }
    .ant-card-meta-title {
      white-space: unset;
      min-height: 50px;
    }
    .teacher-name {
      font-weight: 600;
      font-size: 12px;
      color: #333;
    }
    .old-price {
      text-decoration: line-through;
      font-size: 12px;
    }
    .new-price {
      font-weight: 600;
      font-size: 14px;
      color: #333;
    }
  }
`
